module.exports = __webpack_public_path__ + "assets/chart.15fe45db.svg";